<template>
    <div v-if="isLoaded">
        <div class="content-body">
            <b-modal id="modal_terminal"
                     ref="modal_terminal"
                     :title="modal_titulo"
                     :ok-title="modal_botao"
                     close-title="Fechar"
                     :ok-disabled=form.errors.any()
                     v-model="showModalTerminal"
                     @ok="handleOkTerminal">
                <form @submit.stop.prevent="handleOkTerminal" @keydown="form.errors.clear($event.target.name)">
                  <label>Código</label>
                  <b-form-input type="text"
                                placeholder="Código"
                                v-model="form.cd"
                                name="cd"
                                >
                  </b-form-input>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('cd')" v-if="form.errors.has('cd')"></b-form-feedback>

                  <label>Código Antaq</label>
                  <b-form-input type="text"
                                placeholder="Código Antaq"
                                v-model="form.cd_antaq"
                                name="cd_antaq"
                                >
                  </b-form-input>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('cd_antaq')" v-if="form.errors.has('cd_antaq')"></b-form-feedback>

                  <label>Descrição</label>
                  <b-form-input type="text"
                                placeholder="Descrição"
                                v-model="form.descr"
                                name="descr"
                                >
                  </b-form-input>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('descr')" v-if="form.errors.has('descr')"></b-form-feedback>

                  <label>Código ERP</label>
                  <b-form-input type="text"
                                placeholder="Código ERP"
                                v-model="form.cd_erp"
                                name="cd_erp"
                                >
                  </b-form-input>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('cd_erp')" v-if="form.errors.has('cd_erp')"></b-form-feedback>


                  <label>Status</label>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.status"
                      :options="optionsLivStatusTerminal"
                      name="status"
                      stacked
                      plain
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-feedback v-text="form.errors.get('status')"  v-if="form.errors.has('status')"></b-form-feedback>
                </form>

                    <div slot="modal-footer" class="w-100">
                       <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
                       <div class="float-right">
                           <b-btn @click="showModalTerminal=false" variant="secondary">
                             Fechar
                           </b-btn>
                           <b-btn @click="handleOkTerminal($event)" variant="secondary" :disabled="isDisabled">
                             Enviar
                           </b-btn>
                       </div>
                   </div>
                </b-modal>
        </div>
    </div>
</template>

<script>

export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        loading: false,
        isDisabled: false,
        loadingData: true,
        showModal: false,
        showModalTerminal: false,
        optionsLivStatusTerminal: [],
        activateDesativate: [],
        helpForm: new Form({statusRecord: [], params: []}),
        form: new Form({
                  cd: '',
                  descr: '',
                  cd_erp: '',
                  cd_antaq: '',
                  porto_id: '',
                  terminal_id:'',
                  status: ''
              }),
    fields: [
      {
          name: '__checkbox',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      },
      {
        name: 'cd',
        title: 'Código',
        sortField: 'cd'
      },
      {
        name: 'descr',
        title: 'Descrição',
        sortField: 'descr'
      },
      {
        name: '__slot:status',
        title: 'Status',
        sortField: 'status'
      },
      {
          name: '__slot:actions',   // <----
          title: 'Ações',
          titleClass: 'center aligned',
          dataClass: 'center aligned'
      }
  ],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
methods: {
    handleOkTerminal(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStoreTerminal();
        }
        else
        {
            this.onUpdateTerminal(this.form.terminal_id);
        }
    },
    onCreateTerminal (data) {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Vincular";
        this.modal_botao = "Vincular";
        this.modal_acao = "i";
        this.form.reset();
        this.$parent.optionsLivStatusTerminal.forEach((obj)=>
        {
            this.optionsLivStatusTerminal.push({ text: obj.text, value: obj.value})
        })
        this.form.porto_id = data.porto_id;
        this.$refs.modal_terminal.show();
    },
    onEditTerminal (data) {
        this.isDisabled = false;
        this.loading = false;
        this.modal_titulo = "Alterar";
        this.modal_botao = "Alterar";
        this.modal_acao = "u";
        this.form.reset();
        this.$parent.optionsLivStatusTerminal.forEach((obj)=>
        {
            this.optionsLivStatusTerminal.push({ text: obj.text, value: obj.value})
        })
        this.form.cd = data.cd;
        this.form.descr = data.descr;
        this.form.cd_antaq = data.cd_antaq;
        this.form.cd_erp = data.cd_erp;
        this.form.terminal_id = data.terminal_id;
        this.form.porto_id = data.porto_id;
        this.form.status = data.status.valor;
        this.$refs.modal_terminal.show();
    },
    onStoreTerminal()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/porto/terminal/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
            else
            {
                this.$parent.onFilterReset();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdateTerminal(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/porto/terminal/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
            else
            {
                this.$parent.onFilterReset();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onActivateDesactivate(helpForm)
    {
        helpForm.patch('/api/'+this.rota+'/status').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
            else
            {
                this.$parent.onFilterReset();
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });

    },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>
